import React from 'react';
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { OP_STATUS } from "../../../../util/varibles/constants";
import { convertStepName } from '../../../../util/varibles/global';
import { IOperation2, IService2 } from '../../../../util/varibles/interface';
import Icon, { ICON_NAME } from "../../../Icon";
import ServiceInfo from "../../../Popup/PopupOpInfo/Info/Service/ServiceInfo";
import Header from "../../_components/Header";
import Note from "../../_components/Note";
import StepControl from "../../_components/StepControl";
import TabControl from "../../_components/TabControl";
import ActivityLogs2, { IActivityLogByUnit } from "../../ActivitiesLog/ActivityLogs2";
import stylesOp from "../style.module.scss";

const Service: React.FC = () => {
    const [data] = useTrackingOp(state => state.op as IOperation2<IService2>);

    if (!data) return null;

    const { status, site, sub_operations, current_process } = data.operation;
    const { name: siteName = "" } = site || {}
    const { activity_log = [] } = data;

    const activityLog: IActivityLogByUnit[] = activity_log.reduce((list: any, item: any, index: number) => {
        const { key, unit_id } = item;
        const steps = [{ id: key, name: convertStepName([key]) }];
        const isExist = list.findIndex((sub: any) => sub.id === unit_id);
        const value = { ...item, steps, index };
        if (isExist === -1) {
            return [...list, { id: unit_id, name: unit_id, list: [value] }];
        }
        list[isExist].list.push(value);
        return list
    }, []);

    return <>
        <Header icon={<Icon icon={ICON_NAME.SERVICE} />}>
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span>{[siteName, sub_operations.map((item: any) => item.unit_id).join(', ')].join(' - ')}</span>
            </div>
        </Header>
        <TabControl>
            {[
                <div className={stylesOp['operation-info']} key="info">
                    <div className={stylesOp['operation-content']}>
                        <StepControl />
                        {status === OP_STATUS.PROCESSING && <div className={stylesOp['operation-step-content']}>
                            <ServiceInfo operation={data.operation as IService2} />
                            <Note />
                        </div>}
                    </div>
                </div>,
                <ActivityLogs2
                    key="activity_log"
                    current_process={current_process}
                    activity_log={activityLog}
                    activity_log_root={activity_log}
                />
            ]}
        </TabControl>
    </>;
};

export default Service;
